__webpack_require__.p = "/flashtype/";